import React from 'react';
import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useAuth } from '../../AuthContext';

export default function Navigation() {
  const { isAuthenticated } = useAuth();

  const authenticatedItems: SideNavigationProps['items'] = [
    { type: 'link', text: 'Institution Profile', href: '/institution-profile' },
    { type: 'link', text: 'Annual Submission', href: '/my-submissions' },
    { type: 'link', text: 'Logout', href: '/signout' }
  ];

  // Show empty navigation when not authenticated
  const navigationItems = isAuthenticated ? authenticatedItems : [];

  return (
    <SideNavigation
      header={{ href: '/', text: 'Institution Portal' }}
      items={navigationItems}
    />
  );
}